import React, { Fragment } from 'react';

import { Link } from 'react-router-dom';
import {
	Box,
	ContainerInteractions,
} from './style';

import Status from './Status';
import Annotation from './Annotation';
import Registry from './Registry';
import { ButtonGear } from './Status/style';

const Interactions = ({ demandId }) => (
	<ContainerInteractions>
		{
			demandId ? (
				<Fragment>
					<Box borderRadius="8px 8px 8px 8px" className="mt-3" padding="16px">
						<div className="container-button">
							<Link
								to={`/backoffice/demandas/${demandId}/publicacao`}
							>
								<ButtonGear type="button" className="mt-3">
									Publicar anúncio
								</ButtonGear>
							</Link>
						</div>
					</Box>
					<Box borderRadius="8px 8px 8px 8px" className="mt-3" padding="16px">
						<Status demandId={demandId} />
					</Box>

					<Box borderRadius="8px 8px 8px 8px" className="mt-3" padding="16px">
						<Annotation demandId={demandId} />
					</Box>

					<Registry demandId={demandId} />
				</Fragment>
			) : null
		}
	</ContainerInteractions>
);

export default Interactions;
